import styled from 'styled-components';

export const DownloadReportFormCont = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 158px; // 120px;
`;
export const FormCell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  left: 5px;
`;
